import React from "react";
//import { useParams } from "react-router-dom";

const ErrorPage = () => {
  //const { errorCode } = useParams();
  return (
    <div className="flex items-center" style={{height: "100vh"}}>
      <div className="container w-page p-8">
        <div
          className="
              flex flex-wrap
              my-8
              py-4
              px-8
              border
              rounded
              bg-white
              items-center
            "
        >
          <div className="flex-grow">
            <h2 className="text-18 font-medium" style={{lineHeight: "32px"}}>
              Error
            </h2>
            <p className="text-14 font-medium mt-8">
            We could not complete your request. Please contact your store for further details.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
